import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconExclusiveUse = ({ id, color, width = 19, style, ...restProps }: IProps) => {
  const viewBoxWidth = 19;
  const viewBoxHeight = 16;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M19 5.1c0-.1 0-.1-.1-.2L16.6.4c-.1-.3-.4-.4-.6-.4H3h-.1l-.1.1-.1.1L.1 4.9c-.1 0-.1.1-.1.2V5.4c0 .1.1.1.1.1L9 15.7c.1.1.3.2.5.2s.4-.1.5-.2l8.8-10.1.1-.1v-.2c.1-.1.1-.1.1-.2 0 .1 0 0 0 0zm-4.2-3.8L13.6 4l-2.5-2.7h3.7zm-2.6 3.2H7.1l2.4-2.8 2.7 2.8zM8 1.3l-2.5 3-1.3-3H8zm-4.9.9l1.1 2.3H1.8l1.3-2.3zm-.9 3.7h2.6L7.5 12 2.2 5.9zm7.3 7.2L6.3 5.9h6.5l-3.3 7.2zm2-1.1l2.8-6.1h2.6L11.5 12zm3.3-7.5L15.9 2l1.3 2.5h-2.4z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconExclusiveUse;
